@if (componentData.data$ | async; as component) {
  <div
    class="split-banner"
    [ngClass]="{
      'split-banner-text--right': component.alignment === 'RIGHT',
      'mb-0': component.removeBottomSpacing | safeCheck,
    }"
  >
    <div class="split-banner-text">
      <h3>{{ component.title }}</h3>
      <p>{{ component.subtitle }}</p>
      @if (component.link) {
        <a
          boelsAnchorButton
          boelsGenericLink
          tabindex="0"
          [variant]="'primary-brand'"
          [mode]="'inverted'"
          [componentData]="component"
        >
          {{ component.link.linkName ?? component.title }}
        </a>
      }
    </div>
    <div
      class="split-banner-image"
      [ngClass]="{
        'no-gradient': component.removeGradient | safeCheck,
      }"
    >
      <img
        [src]="getImageSrc(component.image?.url)"
        [alt]="component.imageAltText"
        loading="lazy"
      />
    </div>
  </div>
}
